import tw, { css } from "twin.macro";

export const pill = css`
  ${tw`rounded-full`}
`;

export const rect = css`
  ${tw`rounded-lg`}
`;
